import {
  ACTIVITY_STATUS_LABELS,
  PARTICIPANT_TYPE_LABELS,
  ROLE_LABELS,
  SEMESTER_TYPE_LABELS,
  VALIDATION_STATUS_LABELS,
  type ActivityStatus,
  type ParticipantType,
  type Role,
  type SemesterType,
  type ValidationStatus,
} from "@academichub/shared";

/** Pemformatan tanggal, ukuran berkas, dan label enum untuk seluruh halaman. */

const DATE_FORMAT = new Intl.DateTimeFormat("id-ID", {
  day: "numeric",
  month: "long",
  year: "numeric",
  timeZone: "UTC",
});

const DATE_TIME_FORMAT = new Intl.DateTimeFormat("id-ID", {
  day: "numeric",
  month: "short",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  timeZone: "UTC",
});

const MONTH_FORMAT = new Intl.DateTimeFormat("id-ID", {
  month: "short",
  year: "numeric",
  timeZone: "UTC",
});

export function formatDate(value: string | null | undefined): string {
  if (!value) return "-";
  return DATE_FORMAT.format(new Date(value));
}

export function formatDateTime(value: string | null | undefined): string {
  if (!value) return "-";
  return DATE_TIME_FORMAT.format(new Date(value));
}

export function formatMonth(value: string): string {
  return MONTH_FORMAT.format(new Date(`${value}-01T00:00:00.000Z`));
}

export function formatTimeRange(start: string | null, end: string | null): string {
  if (!start && !end) return "-";
  if (start && end) return `${start} - ${end}`;
  return start ?? end ?? "-";
}

export function formatBytes(size: number): string {
  if (size < 1024) return `${size} B`;
  if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
  return `${(size / (1024 * 1024)).toFixed(1)} MB`;
}

export function activityStatusLabel(status: ActivityStatus): string {
  return ACTIVITY_STATUS_LABELS[status];
}

export function validationStatusLabel(status: ValidationStatus): string {
  return VALIDATION_STATUS_LABELS[status];
}

export function roleLabel(role: Role): string {
  return ROLE_LABELS[role];
}

export function participantTypeLabel(type: ParticipantType): string {
  return PARTICIPANT_TYPE_LABELS[type];
}

export function semesterTypeLabel(type: SemesterType): string {
  return SEMESTER_TYPE_LABELS[type];
}

/** Tanggal ISO untuk input type="date" (YYYY-MM-DD). */
export function toDateInputValue(value: string | null | undefined): string {
  if (!value) return "";
  return new Date(value).toISOString().slice(0, 10);
}

/** Persentase untuk bar distribusi (aman terhadap pembagian nol). */
export function percentage(part: number, total: number): number {
  if (total <= 0) return 0;
  return Math.round((part / total) * 100);
}
